import React, { useState, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const Sidebar = () => {
  const [expanded, setExpanded] = useState(false);
  const sidebarRef = useRef(null);
  const sidebarTextRefs = useRef([]);
  const location = useLocation();

  gsap.registerPlugin(useGSAP);

  useGSAP(() => {
    const sidebar = sidebarRef.current;

    const handleMouseEnter = () => {
      gsap.to(sidebar, {
        width: "16rem",
        duration: 0.1,
        ease: "power2.inOut",
        onStart: () => {
          sidebarTextRefs.current.forEach((text) => {
            if (text) {
              gsap.to(text, {
                opacity: 1,
                visibility: "visible",
                duration: 0.4,
                delay: 0.1,
              });
            }
          });
        },
        onComplete: () => setExpanded(true),
      });
    };

    const handleMouseLeave = () => {
      gsap.to(sidebar, {
        width: "6rem",
        duration: 0.1,
        ease: "power2.inOut",
        onStart: () => {
          sidebarTextRefs.current.forEach((text) => {
            if (text) {
              gsap.to(text, { opacity: 0, visibility: "hidden" });
            }
          });
        },
        onComplete: () => setExpanded(false),
      });
    };

    sidebar.addEventListener("mouseenter", handleMouseEnter);
    sidebar.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      sidebar.removeEventListener("mouseenter", handleMouseEnter);
      sidebar.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <div
      ref={sidebarRef}
      className="fixed top-16 left-0 h-full bg-white shadow-lg z-20 flex flex-col items-start w-24 transition-all duration-100"
    >
      <ul className="space-y-6 w-full overflow-y-auto max-h-[calc(100vh-5rem)] pt-8 pb-8">
        <li>
          <NavLink
            to="/sales/crm"
            className={({ isActive }) =>
              `group flex items-center w-full px-8 py-3 transition-all  ${
                isActive || location.pathname.includes("/sales/crm")
                  ? "bg-blue-100 text-blue-800"
                  : "hover:bg-blue-100 text-gray-700"
              }`
            }
          >
            <i className="fas fa-chart-line text-2xl w-10 h-10 flex justify-center items-center"></i>
            <span
              ref={(el) => (sidebarTextRefs.current[0] = el)}
              className={`ml-1 text-sm font-medium ${expanded ? "" : "hidden"}`}
            >
              CRM
            </span>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/sales/account"
            className={({ isActive }) =>
              `group flex items-center w-full px-8 py-3 transition-all  ${
                isActive
                  ? "bg-blue-100 text-blue-800"
                  : "hover:bg-blue-100 text-gray-700"
              }`
            }
          >
            <i className="fas fa-user-cog text-2xl w-10 h-10 flex justify-center items-center"></i>
            <span
              ref={(el) => (sidebarTextRefs.current[1] = el)}
              className={`ml-1 text-sm font-medium ${expanded ? "" : "hidden"}`}
            >
              Account
            </span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
